/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import { httpStatus4xxList, httpStatus5xxList } from '../../Support/Http/Status/HttpStatus.support';

const ErrorPagePropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The Http status code to display
   */
  status: PropTypes.oneOf([...httpStatus4xxList, ...httpStatus5xxList]).isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default ErrorPagePropTypes;
